import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';

import { RoutePath } from '@components/AppRouter/constants';
import { NEW_ENTITY_ID } from '@components/AppRouter/hooks/constants';
import { usePermission } from '@src/utils/hooks/usePermission';
import { objectFieldsToCamelCase } from '@src/utils/objectFieldsToCamelCase';
import { confirmDialogStore } from '@stores/confirmDialog';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';
import type { ReportGroupsDtoDefId } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

export const ActionButton = observer(({ update }: { update: () => void }) => {
  const { push } = useHistory();
  const { groupDelete, checked, setChecked } = reportGroupsStore;
  const { open: openConfirmDialog } = confirmDialogStore;

  const permission = usePermission('CmReportGroup');

  const onCreate = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT_GROUPS}/${NEW_ENTITY_ID}`);
  }, [push]);

  const onEdit = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT_GROUPS}/${checked[0]?.code}`);
  }, [checked, push]);

  const onDelete = useCallback(() => {
    openConfirmDialog({
      text: `Удалить выбранные элементы (${checked.length})?`,
      onOk: () => {
        const items = checked.map((item) => objectFieldsToCamelCase(item));

        groupDelete(items as ReportGroupsDtoDefId[]).then(() => {
          setChecked([]);
          update();
        });
      },
    });
  }, [checked, groupDelete, openConfirmDialog, setChecked, update]);

  const onCopy = useCallback(() => {
    const isCopy = objectFieldsToCamelCase({ ...checked[0] });
    delete isCopy.openTarget;
    push(`${RoutePath.DICTIONARY_REPORT_GROUPS}/${NEW_ENTITY_ID}`, { isCopy });
  }, [checked, push]);

  return (
    <>
      {permission.CREATE && <IconButton onClick={onCreate} iconName="add" title="Добавить" />}
      {permission.UPDATE && (
        <IconButton onClick={onEdit} disabled={checked.length !== 1} iconName="edit" title="Редактировать" />
      )}
      {permission.DELETE && (
        <IconButton onClick={onDelete} disabled={checked.length === 0} iconName="delete" title="Удалить" />
      )}
      {permission.CREATE && (
        <IconButton onClick={onCopy} disabled={checked.length !== 1} iconName="copy" title="Копировать" />
      )}
    </>
  );
});
